(function () {
  function parseEnd(raw) {
    if (!raw) return null;
    var iso = raw.includes('T') ? raw : raw.replace(' ', 'T');
    var t = Date.parse(iso);
    return Number.isNaN(t) ? null : t;
  }

  function tick(el) {
    var endTime = parseEnd(el.dataset.end);
    var dEl = el.querySelector('[data-alchemy-d]');
    var tEl = el.querySelector('[data-alchemy-t]');
    if (!endTime) {
      el.style.display = 'none';
      return false;
    }
    var diff = endTime - Date.now();
    if (diff <= 0) {
      el.style.display = 'none';
      return false;
    }
    var s = Math.floor(diff / 1000);
    var d = Math.floor(s / 86400);
    var h = Math.floor((s % 86400) / 3600);
    var m = Math.floor((s % 3600) / 60);
    var sec = s % 60;
    if (dEl) dEl.textContent = String(d).padStart(2, '0');
    if (tEl) {
      tEl.textContent =
        String(h).padStart(2, '0') + ':' +
        String(m).padStart(2, '0') + ':' +
        String(sec).padStart(2, '0');
    }
    return true;
  }

  function init() {
    var nodes = document.querySelectorAll('[data-alchemy-countdown]:not([data-alchemy-bound])');
    nodes.forEach(function (el) {
      el.setAttribute('data-alchemy-bound', '');
      if (!tick(el)) return;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  setInterval(function () {
    document.querySelectorAll('[data-alchemy-countdown][data-alchemy-bound]').forEach(tick);
    init();
  }, 1000);
})();
